// extracted by mini-css-extract-plugin
export default {"modalHeader":"FiltersModal_modalHeader__51dit"};